import { useScriptLoad } from './hooks';

export function FueledUsableScript() {
  useScriptLoad(
    {
      id: 'fueled-usable-script',
      src: 'https://a40.usablenet.com/pt/c/brumate/cookiestorestart',
    },
    'head'
  );
  return null;
}
